import React from "react";

// App version. CRA's ModuleScopePlugin forbids importing package.json from
// outside src/, so this is the single source of truth for the web build's
// version — keep it in step with package.json on release.
const APP_VERSION = "0.1.0 (beta)";

// "About this build" content shown inside the CommonUI modal (which provides
// its own Close button). Mirrors the Android AppInfoDialog: title, app name,
// and a version line.
const AppInfoDialog = () => {
  return (
    <div style={styles.container}>
      <h2 style={styles.title}>App Information</h2>
      <p style={styles.appName}>Anothertask</p>
      <p style={styles.version}>Version: {APP_VERSION}</p>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "8px",
  },
  title: {
    margin: 0,
    fontSize: "20px",
    color: "var(--modal-text)",
  },
  appName: {
    margin: 0,
    fontSize: "16px",
    color: "var(--text-muted)",
  },
  version: {
    margin: 0,
    fontSize: "14px",
    color: "var(--text-faint)",
  },
};

export default AppInfoDialog;
